import React, { Component } from "react";
import { IRootState } from "../../interfaces";

import {
  IHelpFaqProps,
  IHelpFaqState,
  IHelpFaqModel,
} from "../../interfaces/help_faq";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { helpFaqRequest } from "../../action";
import { Table } from "react-bootstrap";
// import Loader from "../../components/Loader/Loader";
import { ConfirmBox } from "../../helper/SweetAlert";
import { toast } from "react-toastify";

class Help_Faq extends React.Component<
  IHelpFaqProps,
  IHelpFaqState,
  IHelpFaqModel
> {
  constructor(props: any) {
    super(props);
    this.state = {
      questions: {},
      userAnswer: {},
      questionNumbers: {},
      currentQues: 1,
      maxQuestions: 80,
      quizSummaryData: {},
      quizSubmitted: 0,
      search: "",
    };
  }

  componentDidMount() {
    this.getHelpFaqData();

    window.scrollTo(0, 0);
  }

  componentDidUpdate = (prevProps: IHelpFaqProps, prevState: IHelpFaqState) => {
    const { helpFaqReducer } = this.props;
    // const { helpfaqData } = helpFaqReducer;
  };

  getHelpFaqData = () => {
    const { helpFaqReducer } = this.props;
    if (helpFaqReducer) {
      if (this.props.helpfaqData) {
        this.props.helpfaqData();

        // console.log(">>>>>>>>>", helpFaqReducer);
      }
    }
  };

  render() {
    const { helpFaqReducer } = this.props;
    const { search } = this.state;
    let Questions: any;
    let question =
      helpFaqReducer != undefined
        ? helpFaqReducer["helpfaqData"]
        : " NO HELP FAQ FOUND";
    let tempFAQ: any[] = [];

    for (var i = 0; i <= question.length; i++) {
      const ques = question[i];
      tempFAQ.push(question[i]);
    }
    tempFAQ.pop();

    const printFAQ = () => {
      tempFAQ.map((item: any, index: any) => {
        Questions = item["ques_ans"];
      });
      return <div>{Questions}</div>;
    };
    printFAQ();

    return (
      <>
        <div
          className="main-section module-custom-main" id="right-container">
          <div className="col-lg-12 col-md-12">
            <div className="container">
              <div className="row mb-3">
                <div className="col-lg-6 col-md-6">
                  <div className="quiz-title">Help & FAQs</div>
                </div>
              </div>
            </div>
            <div
              style={{ paddingLeft: "35px" }}
              className="helpFaq-container"
              dangerouslySetInnerHTML={{ __html: Questions }}
            ></div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps: any = (state: IRootState) => ({
  helpFaqReducer: state.helpFaqReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    helpfaqData: (data: any) => {
      dispatch(helpFaqRequest(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Help_Faq);
